import axios from 'axios'
import {
 GET_ALL_DAILY_COLLECTIONS_REQUEST,
 GET_ALL_DAILY_COLLECTIONS_SUCCESS,
 GET_ALL_DAILY_COLLECTIONS_FAIL,
 GET_ALL_DAILY_COLLECTIONS_RESET,
 GET_DAILY_RECOVERY_COLLECTIONS_REQUEST,
 GET_DAILY_RECOVERY_COLLECTIONS_SUCCESS,
 GET_DAILY_RECOVERY_COLLECTIONS_FAIL,
 GET_DAILY_RECOVERY_COLLECTIONS_RESET,
 GET_DAILY_FLOW_COLLECTIONS_REQUEST,
 GET_DAILY_FLOW_COLLECTIONS_SUCCESS,
 GET_DAILY_FLOW_COLLECTIONS_FAIL,
 GET_DAILY_FLOW_COLLECTIONS_RESET,
} from '../constants/dailyMisConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const getAllDailyCollections = (queryParams) => async (dispatch, getState) => {
 try {
   dispatch({
     type: GET_ALL_DAILY_COLLECTIONS_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.get(
     `${baseUrl}/dailyMis/dailyall${queryParams ? `?${queryParams}` : ''}`,
     config
   );

   dispatch({
     type: GET_ALL_DAILY_COLLECTIONS_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: GET_ALL_DAILY_COLLECTIONS_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const getDailyRecoveryCollections = (queryParams) => async (dispatch, getState) => {
 try {
   dispatch({
     type: GET_DAILY_RECOVERY_COLLECTIONS_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.get(
     `${baseUrl}/dailyMis/dailyrecovery${queryParams ? `?${queryParams}` : ''}`,
     config
   );

   dispatch({
     type: GET_DAILY_RECOVERY_COLLECTIONS_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: GET_DAILY_RECOVERY_COLLECTIONS_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const getDailyFlowCollections = (queryParams) => async (dispatch, getState) => {
 try {
   dispatch({
     type: GET_DAILY_FLOW_COLLECTIONS_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.get(
     `${baseUrl}/dailyMis/dailyflow${queryParams ? `?${queryParams}` : ''}`,
     config
   );

   dispatch({
     type: GET_DAILY_FLOW_COLLECTIONS_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: GET_DAILY_FLOW_COLLECTIONS_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};